import SurveysAdapter from './base';

export default class Survey extends SurveysAdapter {
  modelNamePlural = 'surveys';
}
